import country from './country';
import state from './state';
import city from './city';
import check from './check';
import active from './active';
import infoCheck from './infoCheck';

export default {
    country,
    state,
    city,
    active,
    check,
    infoCheck
};


// WEBPACK FOOTER //
// ./src/api/createCompany/index.ts